/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StripeAccountsListResponse
 */
export interface StripeAccountsListResponse {
    /**
     * See https://stripe.com/docs/api/accounts/retrieve
     * @type {Array<object>}
     * @memberof StripeAccountsListResponse
     */
    accounts: Array<object>;
}

/**
 * Check if a given object implements the StripeAccountsListResponse interface.
 */
export function instanceOfStripeAccountsListResponse(value: object): value is StripeAccountsListResponse {
    if (!('accounts' in value) || value['accounts'] === undefined) return false;
    return true;
}

export function StripeAccountsListResponseFromJSON(json: any): StripeAccountsListResponse {
    return StripeAccountsListResponseFromJSONTyped(json, false);
}

export function StripeAccountsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripeAccountsListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'accounts': json['accounts'],
    };
}

export function StripeAccountsListResponseToJSON(json: any): StripeAccountsListResponse {
    return StripeAccountsListResponseToJSONTyped(json, false);
}

export function StripeAccountsListResponseToJSONTyped(value?: StripeAccountsListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accounts': value['accounts'],
    };
}

